import { ReactElement } from "react";
import ReactTooltip from "react-tooltip";

export default function Tooltip(): ReactElement {
  return (
    <ReactTooltip
      place={"bottom"}
      effect={"solid"}
      delayShow={500}
      border={true}
      borderColor={"var(--color-border)"}
      backgroundColor={"black"}
    />
  );
}
